// src/config/api.js - API Configuration for Frontend

// Base API URL - adjust based on your backend setup
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

// API endpoint definitions - ONLY the HTTP endpoints that actually exist
export const API_ENDPOINTS = {
  // Business Authentication endpoints (HTTP)
  businessAuth: `${BASE_URL}/v2/business/auth`,

  // Beta Registration endpoints (HTTP)
  auth: `${BASE_URL}/v2/auth`,

  // File upload endpoints (HTTP)
  files: `${BASE_URL}/v2/business/files`,

  invitation: `${BASE_URL}/v2/public/invitation`,

  // NOTE: Everything else (business, customers, settings, appointments,
  // invoices, team, events, analytics) is handled via WebSocket!
  // Use the SocketManager to communicate with these features.
};

// WebSocket URL configuration
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL || 'http://localhost:5001';

// API configuration constants
export const API_CONFIG = {
  timeout: 30000, // 30 seconds
  retryAttempts: 3,
  retryDelay: 1000, // 1 second
};

// Helper function to build full endpoint URLs
export const buildEndpoint = (base, path) => {
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
};

// Common headers
export const getAuthHeaders = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

export default API_ENDPOINTS;